class OptimumidslandingController {
  constructor($state,$window,storage,laboxSSapi) {
    this.name = 'Optimum IDs';
    this.state = $state;
    this.landingPageOptIDLoader = true;
    this.hasOptimumID = false;
    this.hasNoOptimumID = false;
    this.totalOptIdCount = 0;
    this.errorWhileLoading = false;
    this.currentOptIdCount = 0;
    this.optPrimary = '';
    this.isMaxOptimum = false;

    laboxSSapi.accountInfo().then((res)=>{
      if(res && res.data && !res.data.code){
        console.log("there is no error retrieving accountinfo data");
        if(res.data.userIdsCreated !== 0){
          console.log("there are more than 0 user ids created");
          if(res.data.primaryId != "") {
            console.log("the primary id is not null");
            this.currentOptIdCount = res.data.userIdsCreated;
            this.totalOptIdCount = res.data.maxIdLimit;
            if(this.totalOptIdCount === this.currentOptIdCount){
              this.isMaxOptimum = true;
            } else if(this.currentOptIdCount != null && this.currentOptIdCount > this.totalOptIdCount){
              this.totalOptIdCount = this.currentOptIdCount;
              this.isMaxOptimum = true;
            }
            this.optPrimary = res.data.primaryId;
            storage.setItem('session','maxIdAvailable',this.totalOptIdCount);
            storage.setItem('session','currentOptIdCount',this.currentOptIdCount);
            this.hasOptimumID = true;
            this.landingPageOptIDLoader = false;
          } else {
            console.log("there primary id is null");
            this.errorWhileLoading = true;
            this.landingPageOptIDLoader = false;
          }
        } else if(res.data.userIdsCreated === 0){
          this.hasNoOptimumID = true;
          this.landingPageOptIDLoader = false;
        }
      } else{
        this.errorWhileLoading = true;
        this.landingPageOptIDLoader = false;
      }
    });
  }
}

OptimumidslandingController.$inject = ['$state','$window','storage','laboxSSapi'];

export default OptimumidslandingController;



// WEBPACK FOOTER //
// ./client/app/components/landingpage/optimumidslanding/optimumidslanding.controller.js